import axios from 'axios';
import CommonConstants from '../utils/CommonConstants';
const apiUrl = CommonConstants.Actions.api;

export function getCustomerInfo(token){
	var config = {
		headers: {  
        'authorization' :'Bearer '+ token,       
       },
	}
  return function(dispatch){
    dispatch({type: 'RESET_UPDATE',})
    axios.get(apiUrl+'accounts',config).then((response) => {
      dispatch({type: 'GET_CUSTOMER_INFO_FULFILLED', payload: response.data,})
    }).catch((err) =>{
      dispatch({type: 'GET_CUSTOMER_INFO_REJECTED', payload: err,})
    })
  }
 }
export function getWarehouse(){
  return function(dispatch){
    axios.get(apiUrl+'warehouse').then((response) => {
      dispatch({type: 'GET_WAREHOUSE_FULFILLED', payload: response.data,})
    }).catch((err) =>{
      dispatch({type: 'GET_WAREHOUSE_REJECTED', payload: err,})
    })
  }
 }








/** WEBPACK FOOTER **
 ** ./src/actions/DashboardActions.js
 **/